import { supabase } from "@/integrations/supabase/client";
import { NotificationService } from "@/services/notificationService";
import { Notification } from "@/types";

export const useNotificationActions = (
  setNotifications: React.Dispatch<React.SetStateAction<Notification[]>>
) => {
  const markNotificationAsRead = async (id: string) => {
    try {
      const { error } = await supabase
        .from('notifications')
        .update({ read: true })
        .eq('id', id);
        
      if (error) {
        // intentionally empty
      }
      
      setNotifications((prev: Notification[]) =>
        prev.map((notification) =>
          notification.id === id ? { ...notification, read: true } : notification
        )
      );
    } catch {

      // intentionally empty
    }
  };

  const deleteNotification = async (id: string) => {
    try {
      // Call the NotificationService to delete the notification
      await NotificationService.deleteNotification(id);
      
      // Update local state by filtering out the deleted notification
      setNotifications((prev) => 
        prev.filter((notification) => notification.id !== id)
      );
    } catch {

      // intentionally empty
    }
  };

  return { markNotificationAsRead, deleteNotification };
};
